import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, contains } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectedCliente } from "./types";

/**Determina si una guia esta seleccionada */
function estaSeleccionada(item: models.ClienteView, selected: number[]): boolean {
    return contains(selected, item.IdCliente);
}

/**Obtiene un conjunto de guias a un conjunto de SelectedGuia */
export function toSelected(items: models.ClienteView[], selected: number[]): SelectedCliente[] {
    const ret = items.map(x => ({ ...x, Selected: estaSeleccionada(x, selected) }));
    return ret;
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/clientesfinales/logic.tsx